module.exports = __webpack_public_path__ + "static/img/logo.3250db09.png";